import { QueryClientProvider } from '@tanstack/react-query';
import type { JSX } from 'react';
import { createBrowserRouter, Outlet } from 'react-router';

import { queryClient } from '../lib/api/client.js';
import { pageRoutes } from '../pages/routes.js';
import { useAuthorizationRefresh } from './authorization.js';

function Root(): JSX.Element {
  useAuthorizationRefresh();
  return (
    <QueryClientProvider client={queryClient}>
      <main>
        <Outlet />
      </main>
    </QueryClientProvider>
  );
}

export const router = createBrowserRouter([
  {
    Component: Root,
    children: pageRoutes,
  },
]);
